var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #062860;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "156.84 221.1 93.1 230.47 102.47 166.73 187.68 81.52 242.05 135.89 156.84 221.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.04,52.95h39.09c10.43,0,18.9,8.47,18.9,18.9v29.17h-76.89v-29.17c0-10.43,8.47-18.9,18.9-18.9Z",
    transform: "translate(126.66 -151.81) rotate(45)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.06,120.41h164.9v-29.02H17.06v29.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.06,189.89h63.66v-29.02H17.06v29.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.06,259.37h202.92v-29.02H17.06v29.02Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTodo);
export default __webpack_public_path__ + "static/media/icon_todo.f8b0ac3cee5a483611717658e6fc28d4.svg";
export { ForwardRef as ReactComponent };